export default {
  settings: {},
}
